/**
 * Employee Web — `/me/tasks/$id` detail route.
 *
 * Notifications deep-link to this path, so it must exist and resolve
 * deterministically: non-UUID URLs 404 (same guard as the expense detail).
 */
import type { JSX } from "react";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { MyTaskDetail } from "@linkhr/employee-self-service";

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const Route = createFileRoute("/_auth/me/tasks/$id")({
  staticData: { breadcrumb: { labelKey: "tasks:nav.myTasks" } },
  beforeLoad: ({ params }) => {
    if (!UUID_REGEX.test(params.id)) {
      throw notFound();
    }
  },
  component: MeTaskDetailRoute,
});

function MeTaskDetailRoute(): JSX.Element {
  const { id } = Route.useParams();
  return <MyTaskDetail taskId={id} />;
}
